export default __webpack_public_path__ + "static/media/ip-addressImg_2.d724c6fd.png";